<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <CCard>
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Dokumen Pengajuan Waiverf
        <CButton
            color="success"
            style="float:right;margin-right:10px"
            class="btn-md ml-auto"
            @click="myModal = true"
        >Kirim Dokumen</CButton>

        <Button
          class="btn btn-md btn-dark  float-right   text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <!-- Data dokumen -->
      <CCardBody>
        
        <CRow>
          <div class="col-sm-12 col-xl-2">

            <div class="form-group">
              <label for>Data Perhalaman</label>
              <select class="form-control" name id>
                <option>10</option>
                <option>25</option>
                <option>100</option>
                <option>Semua Data</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-xl-3 ml-auto">
            <div class="form-group">
              <label for>Pencarian</label>
              <input type="text" name id class="form-control" placeholder="Cari Data ..." />
            </div>
          </div>
        </CRow>
        <CRow>

          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{index}">
                <td class="py-2">{{ indexed == 0 ? index+1: index+indexed + 1 }}</td>
              </template>
              <template #file="{item}">
                <td  class="text-center"  >
                    <a href="https://">{{ item.file }}</a>
                </td>
              </template>
              <template #upload_pada="{item}">
                <td class="py-2 text-left">{{item.upload_pada ? item.upload_pada : "-"}}</td>
              </template>
            
           
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="10"
              responsive
            />
          </CCol>
        </CRow>
        <!-- Modal Tambah -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm v-on:submit.prevent="postData">
            <CRow>
              <CCol sm="12">
                <div class="custom-file text-truncate">
                    <input
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    />
                    <label
                    class="custom-file-label"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                    >name file</label>
                </div>
                <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Kirim Dokumen Waiver</h6>
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton @click="postData" type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data BPK -->
    </CCard>
  </div>
</template>
<script>
import AseanCpaService from "../../../services/keanggotaan/asean-cpa.service";
const items = [
  {
    no: "1",
    file: 'Dokumen Pengajuan 1.pdf',
    upload_pada: "kamis, 20 Januari 2020",
  },
  {
    no: "2",
    file: 'Dokumen Pengajuan 2.pdf',
    upload_pada: "kamis, 20 Januari 2020",
  },
  {
    no: "3",
    file: 'Dokumen Pengajuan 3.pdf',
    upload_pada: "kamis, 20 Januari 2020",
  },
  
];

const fields = [
  {
    key: "no",
    label: "No",
    sorter: false,
    filter: false
  },
  {
    key: "file",
    label: "Lihat File",
    _classes: 'text-center',
    sorter: true,
    filter: false
  },
  {
    key: "upload_pada",
    label: "Tanggal Upload",
    sorter: true,
    filter: false
  },

];

export default {
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL_FO_USER+"/",
      items: items.map((item, id) => {
        return { ...item, id };
      }),
    //   items: [],
      // formData: {
      //   judul: "",
      //   file: ""
      // },
      formData: {
        idDokumenAseanCpa: "",
        deskripsi: "",
        file: "",
        statusUpload: "",
        updated_at: "",
        tanggal_verifikasi: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    // this.getDataDokumen();
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
          format: "YYYY-MM-DD"
        },
        function(start, end, label) {
          // this.formData.tanggal_verifikasi = end.format("YYYY-MM-DD")
          // comment console console.log(
            
          // this.formData.tanggal_verifikasi = start.format("YYYY-MM-DD") +
          //     " to " +
          //     end.format("YYYY-MM-DD");
          // end.format("YYYY-MM-DD");
        }
      );
    });
  },
  methods: {
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    getDataDokumen() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.$formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      AseanCpaService.getDokumenMasterCpa(this.$route.params.id_asean_cpa)
        .then(response => {
          loader.hide();
          this.items = response.data.data;
          // comment console console.log(response);
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    verifikasiDokumen(
      idDokumenAseanCpa,
      statusUpload,
      tanggal_verifikasi,
      index
    ) {
      this.myModal = true;
      this.formData.idDokumenAseanCpa = idDokumenAseanCpa;
      this.formData.statusUpload = statusUpload;
      // this.formData.updated_at = updated_at;
      this.formData.tanggal_verifikasi = tanggal_verifikasi;
      this.index = index;
    },
    postData() {
      var vm = this;
      AseanCpaService.putStatusTerverifikasi(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.myModal = false;
          this.alertVerif();
          vm.getDataDokumen();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>